<template>
    <div>
        <div id="heasers">
            <div class="header-wrap">
                <div class="header">
                    <span class="left"
                          @click="goBack"><i class="icon-fanhui"></i></span>
                    <div class="ellipsis">选择作业类型</div>
                    <slot></slot>
                </div>
            </div>
        </div>
        <div class="task-type">

            <div class="activity_img"
                 v-if='is_show'
                 @click='clickUrl'>
                <img :src="`${user_type==2?'/static/img/icon_img_1.png':'/static/img/icon_img_2.png'}`">
            </div>
            <div class="content">
                <div class="d_title">
                    <span class="h2">个性化学习</span>
                    <img src="./img/icon-new.png"
                         class="icon-new"
                         alt="">
                </div>
                <div class="d_con bor_bottom"
                     @click='exercises'>
                    <div>
                        <img src="./img/icon_exer.png"
                             alt="">
                    </div>
                    <div class="d_center ">
                        <p class="h3">同步习题</p>
                        <p>课时同步，学生完成后，推送个性化学习报告</p>
                    </div>
                    <div>
                        <em></em>
                    </div>
                </div>
                <div class="d_con bor_bottom"
                     @click='weekedTest'>
                    <div>
                        <img src="./img/icon_weekend.png"
                             alt="">
                    </div>
                    <div class="d_center ">
                        <p class="h3">每周一测</p>
                        <p>每周一测，学生完成后，推送个性化学习报告</p>
                    </div>
                    <div>
                        <em></em>
                    </div>
                </div>
                <div class="d_con spacing"
                     @click='review'>
                    <div>
                        <img src="./img/icon_united.png"
                             alt="">
                    </div>
                    <div class="d_center">
                        <p class="h3">单元复习</p>
                        <p>综合测试，学生完成后，推送个性化学习报告</p>
                    </div>
                    <img src="./img/icon_activity.png"
                         alt=""
                         class="qimo_paper"
                         v-if='sid == 21&&isActivity'>
                    <div>
                        <em></em>
                    </div>
                </div>

                <div class="d_title">
                    <span class="h2">拓展学习</span>
                </div>
                <div class="d_con bor_bottom"
                     v-if='sid == 21'
                     @click='knowledge'>
                    <div>
                        <img src="./img/icon_knowledge.png"
                             alt="">
                    </div>
                    <div class="d_center">
                        <p class="h3">知识点视频</p>
                        <p>课时同步知识点视频、发给学生观看、提前预习。</p>
                    </div>
                    <div>
                        <em></em>
                    </div>
                </div>
                <div class="d_con bor_bottom"
                     v-if='sid == 21'
                     @click='quick'>
                    <div>
                        <img src="./img/icon_quick.png"
                             alt="">
                    </div>
                    <div class="d_center">
                        <p class="h3">速算</p>
                        <p>口算练习、限时训练</p>
                    </div>
                    <div>
                        <em></em>
                    </div>
                </div>
                <div class="d_con bor_bottom"
                     @click="toWrong">
                    <div>
                        <img src="./img/icon_wrong.png"
                             alt="">
                    </div>
                    <div class="d_center">
                        <p class="h3">高频错题</p>
                        <p>班级每周错误率高的试题</p>
                    </div>
                    <div>
                        <em></em>
                    </div>
                </div>
                <div class="d_con spacing"
                v-if="inApp"
                     @click='extrac'>
                    <div>
                        <img class="Stars"
                             src="./img/icon_extr.png"
                             alt="">
                    </div>
                    <div class="d_center">
                        <p class="h3">课外活动</p>
                        <p>手抄报、做家务、自我展示等</p>
                    </div>
                    <div>
                        <em></em>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'SRC/components/base/header.vue';

export default {
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            titles: '选择作业类型',
            sid: this.$route.params.subject, //学科// 21 22
            type: this.$route.query.type,
            user_type: Number(this.$route.query.user_type),
            is_show: Number(this.$route.query.is_show),
            isActivity: false,
            is_active: Number(this.$route.query.is_active) || 0, //是否来自寒假活动
            // hdUrl:'',
            is_finish: localStorage.getItem('subjectLength') <= 1//从本地读取教师带的科目数并判断
        }
    },
    methods: {
        //每周一测

        exercises () {
            //同步习题
            this.$router.push('/sx/testPaper/taskset/21/1')
        },
        weekedTest () {
            //每周一测
            this.$router.push('/sx/testPaper/taskset/21/2')
        },
        review () {
            //单元复习
            this.$router.push('/sx/testPaper/taskset/21/3')
        },

        knowledge () {
            // 知识点视频
            if (this.is_active) { //来自寒假活动
                this.$router.push('/sx/knowledge/taskset?is_active=2')
            } else {
                this.$router.push('/sx/knowledge/taskset')
            }
        },
        quick () {
            // 速算作业
            this.$router.push('/sx/quick/selected')
        },
        toWrong () {
            //高频错题
            if (this.sid == 21) {
                // 高频错题
                this.$router.push('/sx/wrong/index/21')
            } else {
                this.$router.push('/sx2/wrong/index/22')
            }

        },


        extrac () {
            if (this.sid == 21) {
                // try {
                //   appobject.Interactive('ys_task_kwhd,21')
                // } catch (e) {
                //   //console.log(e)
                // }
                this.appFunction("ys_task_kwhd", "21");
            } else {
                // try {
                //   appobject.Interactive('ys_task_kwhd,22')
                // } catch (e) {
                //   //console.log(e)
                // }
                this.appFunction("ys_task_kwhd", "22");
            }
        },
        clickUrl () {
            let url = this.user_type == 1 ? `/activity/activation/active` : `/activity/activation/silent`;
            this.$router.push(url);
        },
        // tohd(){
        //   if(this.hdUrl!=''){
        //     this.$router.push(this.hdUrl+'&teahd=1');
        //   }
        // }
        goBack () {
            if (this.is_finish) {
                if(this.inApp){
                    this.appFunction("ys_finish");
                }else{
                    this.$router.push('/')
                }
            } else {
                console.log('asdadad')
                this.$router.push('/subjectChoose/0')
            }
        }

    },
    components: {
        headers,
    },
    created () {
        localStorage.removeItem('math_send_ok');
        let EndTime = new Date('2020/1/31 23:59:59').valueOf();
        let today = new Date().valueOf();
        this.isActivity = today > EndTime ? false : true;
        // this.$http.post(API_URL_TASK_API + '/activity/task/').then((res) => {
        //   if (res.data.response === 'ok') {
        //     this.hdUrl= res.data.data.split(".cn")[1];
        //   }
        // })
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.spacing {
    margin-bottom: 20px / $ppr;
}

.h2 {
    font-size: 30px / $ppr;
    line-height: 30px / $ppr;
    font-weight: bold;
}

.h3 {
    font-weight: bold;
}

.bor_bottom {
    border-bottom: 1px / $ppr solid #e8e8e8;
}

.task-type {
    min-height: 100vh;
    .header {
        background: #5e89ef;
        .left {
            display: block;
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url("./img/choose_back.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}

.activity_img {
    height: 228px / $ppr;
    padding: 0 25px / $ppr;
    background: #fff;
    img {
        position: relative;
        top: 24px / $ppr;
        display: block;
        height: 200px / $ppr;
        z-index: 3;
    }
}

.content {
    .d_title {
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        border-bottom: 1px / $ppr solid #e8e8e8;
        padding-left: 24px / $ppr;
        background: #fff;
        span {
            padding-left: 16px / $ppr;
            border-left: 4px / $ppr solid #5e89ef;
        }
        .icon-new {
            height: 30px / $ppr;
            position: relative;
            top: 4px / $ppr;
            left: 5px / $ppr;
        }
    }
    .d_con {
        height: 150px / $ppr;
        background: #fff;
        padding: 0 24px / $ppr;
        display: flex;
        display: -webkit-flex;
        position: relative;
        div {
            height: 100%;
            display: inline-block;
        }

        .qimo_paper {
            width: 136px / $ppr;
            height: 36px / $ppr;
            position: absolute;
            top: 29px / $ppr;
            left: 225px / $ppr;
        }

        div:nth-of-type(1) {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            -webkit-justify-content: center;
            align-items: center;
            -webkit-align-items: center;
            img {
                width: 56px / $ppr;
                height: 56px / $ppr;
                &.Stars {
                    width: 56px / $ppr;
                    height: 56px / $ppr;
                }
            }
        }
        .d_center {
            padding-left: 20px / $ppr;
            p {
                height: 75px / $ppr;
                line-height: 100px / $ppr;
                text-align: left;
            }
            p:nth-of-type(2) {
                color: gray;
                line-height: 50px / $ppr;
                font-size: 24px / $ppr;
            }
        }
        div:nth-of-type(3) {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            -webkit-justify-content: center;
            align-items: center;
            -webkit-align-items: center;
            -webkit-box-align: center;
            position: absolute;
            right: 22px / $ppr;
            em {
                display: inline-block;
                width: 20px / $ppr;
                height: 30px / $ppr;
                background: url("./img/icon_next.png");
                background-repeat: no-repeat;
                background-size: contain;
            }
        }
    }
}
.font-italic {
    font-style: italic;
}
.header-wrap .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 8;
    height: $h-header;
    line-height: $h-header;
    color: #fff;
    font-size: 34px / $ppr;
    text-align: center;
    background: #5e89ef;
    .icon-fanhui {
        display: block;
        width: 76px / $ppr;
        height: $h-header;
        background-image: url("./img/back.png");
        background-position: center;
        background-size: 18px / $ppr 34px / $ppr;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
    }
    .ellipsis {
        width: 520px / $ppr;
        margin: 0 auto;
    }
}
</style>
